<template>
  <div>
    <v-head></v-head>
    <div style="width: 100%; background-color: #fff">
      <div class="infoDetailsBox_header">
        <div class="logo" @click="$router.push('/index')">
          <img src="/static/image/newLogo.png" />
          <div class="line"></div>
          <div class="logo-des">
            <p>消费帮促</p>
            <p>采购平台</p>
          </div>
        </div>
        <div class="headerContent">
          <img class="headerImg" src="/static/image/infoTop.png" />
          <div>—— 资讯中心 ——</div>
        </div>
      </div>
    </div>
    <div class="infoDetailsBox">
      <div class="infoDetails_title">{{ infoData.title }}</div>
      <div v-html="infoData.content"></div>
    </div>
  </div>
</template>
<script>
import vHead from "../common/header2.vue";
import { doGet } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
export default {
  components: { vHead },
  data() {
    return {
      infoData: "",
    };
  },
  watch: {
    $route(to, from) {
      this.getData(this.$route.query.id);
    },
  },
  mounted() {
    this.getData(this.$route.query.id);
  },
  methods: {
    getData(id) {
      var that = this;
      doGet(
        httpConfig.infoDetails.getDataUrl,
        { id: id },
        function (res) {
          that.infoData = res;
        },
        function (res) {}
      );
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/infoDetails";
</style>



// WEBPACK FOOTER //
// src/components/page/infoDetails.vue